<template>
	<div>
		<h3>结算账单</h3>
		<div class="searchBox">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="时间范围">
					<el-date-picker v-model="formInline.time" type="daterange" align="right" unlink-panels range-separator="至"
					 start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" :default-time="['00:00:00', '23:59:59']" value-format="timestamp">
					</el-date-picker>
				</el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.docNo" placeholder="请输入订单号"></el-input>
				</el-form-item>
				<el-button class="text2 " type="primary" @click='indexPage=0;getData()'>查询</el-button>
			</el-form>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%"  height='calc(100vh - 300px)'>
				<el-table-column prop="bill.id" label="ID" width="80"></el-table-column>
        <el-table-column label="订单号" width='170'>
					<template slot-scope="scope">{{ scope.row.bill.billingNo }}</template>
				</el-table-column>
				<el-table-column label="账单时间" width='170'>
					<template slot-scope="scope">{{ setTime(scope.row.cut.createAt) }}</template>
				</el-table-column>
				<el-table-column label="商品">
					<template slot-scope="scope">
						<span>{{scope.row.product ? scope.row.product.name : '实体卡'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="类型" align="center" width="100">
					<template slot-scope="scope">
						{{typeRstatus[scope.row.cut.rtype - 1]}}
					</template>
				</el-table-column>
				<el-table-column label="数量" align='center' width="100">
					<template slot-scope="scope">
						<span class="yellow"> {{scope.row.cut.billDetailCount}} 个</span>
					</template>
				</el-table-column>
				<el-table-column label="收入类型" width="100">
					<template slot-scope="scope">
						<span :class="scope.row.cut.type == 1?'green':'red'">{{scope.row.cut.type == 1 ?'收入 ':'支出 '}}</span>
					</template>
				</el-table-column>
				<el-table-column label="流水金额" width="100">
					<template slot-scope="scope">
						<span :class="scope.row.cut.type == 1?'green':'red'">{{scope.row.cut.amount/100}} 元 </span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="channel.name" label="渠道"></el-table-column> -->
				<el-table-column label="付款金额" width="100">
					<template slot-scope="scope">
						<span>￥{{scope.row.bill.saleAmount/100}}元</span>
					</template>
				</el-table-column>
				<el-table-column label="订单状态" width="130">
					<template slot-scope="scope">
						<span class="yellow">{{billingState[scope.row.bill.billingState]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" width="100" align="center">
					<template slot-scope="scope">
						<router-link v-if='scope.row.bill.billingType == 1' class="blue" :to="{path:'/financial/yesSettlement/financialDetails',query:{id:scope.row.bill.id}}">查看详情</router-link>
						<router-link v-else class="blue" :to="{path:'/financial/cardorderDetail1',query:{id:scope.row.bill.id}}">查看详情</router-link>

					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<span class="money">订单金额：<span>{{moneyOrder}}</span>元</span>
			<span class="money">流水金额：<span>{{moneyFencheng}}</span>元</span>
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import { listByState,getMoneyOfTwo } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				formInline: {
					type: '',
					time: '',
					startts:'0',
					endts:'',
          docNo:''
				},
				tableData: [],
				billingState:['创建','线上支付完成','挂帐月结-未付','线下转账-已付款','已退单','投保失败退单'],
				pickerOptions2: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页
				typeRstatus:['订单' , '分成' , '退单-订单' , '退单-分成'],
				moneyOrder:'',
				moneyFencheng:''
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},
			setTime(str) {
				return common.time(str)
			},
			getData(){
				var day='';
				var time=(new Date()).getTime()
				var data={}
				if(this.formInline.time == null){
					data={
						state:this.formInline.type,
						start:this.indexPage,
						count:this.eachPage,
						startts:0,
						endts:time,
            docNo:this.formInline.docNo
					}
				}else{
					data={
						state:this.formInline.type,
						start:this.indexPage,
						count:this.eachPage,
						startts:this.formInline.time[0],
						endts:this.formInline.time[1],
            docNo:this.formInline.docNo
					}
				}


				listByState(data)
				.then(res => {
					console.log(res)
					this.tableData=res.data.obj;
					this.allpage=res.data.total;
					// this.handleSizeChange(this.eachPage);
				})
				.catch(err => {
					console.log(err)
				})
        console.log(this.formInline.time)
				var data1={
					state:this.formInline.type,
					startts:data.startts,
					endts:data.endts
				}
				getMoneyOfTwo(data1)
				.then(res => {
					this.moneyOrder=(res.data.obj/100).toFixed(2);
					this.moneyFencheng=(res.data.obj2/100).toFixed(2)
				})
				.catch(err => {
					console.log(err)
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>
<style>
	.el-range-separator {
		width: 20px !important;
	}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}
	.text{line-height: 32px;}
	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}
	.fenye .button{float: left;}
	.fenye .pagination {
		float: right;
	}
	.money{
		color: #333;
		font-size: 14px;
		margin-right: 20px;
		font-weight: bold;
	}
	.money span{
		color: #ff7200;
		padding-right: 6px;
	}
</style>



// WEBPACK FOOTER //
// src/views/financial/index.vue